export const PRODUCTS_KEY = 'products';
export const PRODUCTS_FILTER_PARAM_KEY = 'products-filter';
export const DEFAULT_CATEGORY_FILTER = 'all';
